module.exports = __webpack_public_path__ + "static/media/mktools.7a0e9755.svg";